import React from 'react'

import TableBody from '@mui/material/TableBody';

import StandardsExpectation from './standards-expectation';
import StandardsIndicators from './standards-indicators';
import useStyles from './styles'

export default function StandardsBody({context, stds, indicatorCode}) {
  
  const classes = useStyles()

  const {standardsContext, quizAssessmentToReview: standards} = context
  
  const {assessmentIndicators} = standardsContext

  const hasReferences = stds.references.length > 0;

  const hasIndicators = Object.keys(assessmentIndicators).length > 0;

  return (
        <TableBody className={classes.tableBody}>
            {hasReferences && hasIndicators && stds.references?.map((row, index) => {
                let countAnswered = 0;
                let pending = false;
                let percent = 0;
                let countTotal = assessmentIndicators[row.id][0].references !== undefined ? assessmentIndicators[row.id][0].references.length : 0;

                assessmentIndicators[row.id][0]?.references.forEach(question => {
                    if (standards.results[question.id].points > 0 ) countAnswered++;
                    if (standards.results[question.id].pending) pending = true;
                })
                if(indicatorCode.indexOf(assessmentIndicators[row.id][0].code) === -1){
                    indicatorCode.push(assessmentIndicators[row.id][0].code);
                    percent = (countAnswered/countTotal)*100; 

                }else{
                    return
                }

                return(
                    <StandardsIndicators 
                        context={context} 
                        indicator={assessmentIndicators[row.id][0]} 
                        percent={percent} 
                        pending={pending} 
                        countAnswered={countAnswered} 
                        countTotal={countTotal} 
                        key={index}/>
                    )
                
            })}
            {!hasIndicators && stds.expectations.map((expectation, index) => {
                    let countAnswered = 0;
                    let pending = false;
                    let percent = 0;
                    let countTotal = expectation.references.length;
                    expectation.references.forEach(question => {
                        if (standards.results[question.id].points > 0 ) countAnswered++;
                        if (standards.results[question.id].pending) pending = true;
                    })
                    
                    if(indicatorCode.indexOf(expectation.description) === -1){
                        indicatorCode.push(expectation.description);
                        percent = (countAnswered/countTotal)*100; 
                    
                    }else{
                        return
                    }

                    return(
                        <StandardsExpectation 
                            context={context} 
                            expectation={expectation} 
                            percent={percent} 
                            pending={pending} 
                            countAnswered={countAnswered} 
                            countTotal={countTotal} 
                            key={index}/>
                    )
            })}
        </TableBody>
  )
}
